import React from "react";
import pieColors from "./pieColors";

const LegendInfo = ({ gesamt, data = [], className = "", textSize = "text-sm" }) => {
    const getValue = (name) => data.find((item) => item.name === name)?.value ?? '';

    return (
    <div className={className}>
        <p className={`${textSize} font-semibold mb-3`}>Gesamt: {gesamt.toLocaleString("de-DE")}</p>
        <p className={`${textSize} flex items-center gap-2`}>
            <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ backgroundColor: pieColors.inactive }}
            ></span>
                inaktiv {getValue("inaktiv").toLocaleString("de-DE")}
        </p>
        <p className={`${textSize} flex items-center gap-2`}>
            <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ backgroundColor: pieColors.active }}
            ></span>
                aktiv {getValue("aktiv").toLocaleString("de-DE")}
        </p>
        <p className={`${textSize} flex items-center gap-2`}>
            <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ backgroundColor: pieColors.completed }}
            ></span>
                abgeschlossen {getValue("abgeschlossen").toLocaleString("de-DE")}
        </p>
        <p className={`${textSize} flex items-center gap-2`}>
            <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ backgroundColor: pieColors.canceled }}
            ></span>
                abgesagt {getValue("abgesagt").toLocaleString("de-DE")}
        </p>
    </div>
);
};

export default LegendInfo;
